import { Injectable } from 'injection-js';
import { Module, Http, State, TurboLinks } from 'shared/core';
import { Actions } from 'shared/state';

@Injectable()
export class OnlineReturnsConfirmModule extends Module {

  constructor(
    public http: Http,
    public state: State,
    public turbolinks: TurboLinks,
  ) {
    super();
  }

  public init(): void {
    $('body').on('change', '#acceptTerms', (e: JQuery.ChangeEvent) => this.toggleConfirm(e.target.checked));

    $('body').on('click', '.confirmReturnOpen', (e: JQuery.ClickEvent) => {
      const form = $('#return-data')[0] as HTMLFormElement;

      let valid = true;
      if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
        valid = false;
        if (form.reportValidity) {
          valid = form.reportValidity();
        }
      }

      if (valid) {
        this.state.dispatch({ name: Actions.OPEN_DYNAMIC_MODAL, payload: { url: (e.target as HTMLElement).dataset.ajax } });
      }
    });

    $('body').on('submit', '#confirm_return_form', e => {
      e.preventDefault();
      $('#return-data').trigger('submit');
      this.state.dispatch({ name: Actions.CLOSE_MODAL });
    });
  }

  private toggleConfirm(valid: boolean): void {
    $('#returnSubmit').prop('disabled', !valid);
  }
}
